// extracted by mini-css-extract-plugin
module.exports = {"form":"_2FQZ1x","input":"_2WjZVL","button":"_2_iXfN"};